<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Html',
              type: 'textarea',
              modelPath: [this, 'form', 'content'],
              multilingual: true,
              required: true
            })
          ]
        }
      ]
    }
  }
}
</script>
